import request from '@/utils/request'

/** 获取NTC权限配置 */
export function getNTCConfig() {
  return request({
    url: `/user/config`,
    method: 'get'
  })
}
